import { getDefaultExportFromCjs as t } from "../../_virtual/_commonjsHelpers.js";
import { _ as o } from "./_baseMerge.js";
import { _ as s } from "./_createAssigner.js";
var m = o, g = s, f = g(function(e, r, a) {
  m(e, r, a);
}), i = f;
const c = /* @__PURE__ */ t(i);
export {
  c as default
};
//# sourceMappingURL=merge.js.map
